import { CheckRule } from '../../constants/regular.constant';

/**
 * 判断税务注册号是否可以复制到增值税号。
 * @param fiscalCode 当前税务注册号
 * @param regularType 复制目标字段使用的校验规则，未传入时使用税务注册号规则
 * @returns 税务注册号非空且格式有效时返回 true
 */
export function isFiscalCodeValidForCopy(fiscalCode: string, regularType = 'fiscalCode'): boolean {
    return Boolean(fiscalCode.trim()) && CheckRule(regularType, fiscalCode);
}
